import React, { useEffect, useState } from "react";
// import { supabase } from "../supabaseClient";
import supabase from "../supabaseClient";
import { Link } from "react-router-dom";

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [search] = useState("");

  const fetchBlogs = async () => {
    const { data } = await supabase
      .from("blogs")
      .select("*")
      .order("created_at", { ascending: false });
    setBlogs(data || []);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const filteredBlogs = blogs.filter((b) =>
    b.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      {/* HERO SECTION (Static Featured Banner) */}
      <div className="rounded-2xl overflow-hidden relative h-64 md:h-96 mb-12 shadow-lg">
        <img
          src="/images/blog-hero.jpg"
          alt="Blog Hero"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center px-6 text-white">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-2">
            Browse Our Resources
          </h2>
          <p className="max-w-xl text-sm md:text-lg opacity-90">
            Insights, tips & trends directly from the financial industry
            experts.
          </p>
        </div>
      </div>

      {/* Blog Cards */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredBlogs.length > 0 ? (
          filteredBlogs.map((blog) => (
            <Link
              to={`/blog/${blog.slug}`}
              key={blog.id}
              className="border rounded-xl overflow-hidden bg-white shadow hover:shadow-xl transition"
            >
              <img
                src={blog.banner_url}
                alt=""
                className="h-40 md:h-48 w-full object-cover"
              />

              <div className="p-4">
                <h3 className="text-lg font-semibold mb-2 line-clamp-2">
                  {blog.title}
                </h3>

                {/* Created Date */}
                <p className="text-xs text-gray-500 mb-2">
                  {new Date(blog.created_at).toLocaleDateString("en-IN", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </p>

                {/* Short Clean Content */}
                <div
                  className="text-gray-600 text-sm line-clamp-3"
                  dangerouslySetInnerHTML={{
                    __html:
                      blog.content
                        .replace(/<[^>]+>/g, "") // Remove all HTML tags
                        .slice(0, 140) + "...",
                  }}
                ></div>
              </div>
            </Link>
          ))
        ) : (
          <p className="text-gray-500 text-center col-span-full pt-10">
            No blogs found
          </p>
        )}
      </div>
    </div>
  );
}
